import React from "react";

export default function SPYellow() {
  return (
    <svg
      width="54"
      height="52"
      viewBox="0 0 54 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9959 3.1178C23.0734 6.80427 19.3254 14.4068 23.0868 23.9133C26.608 32.7041 34.7042 42.9263 34.8243 43.0478L3.01288 24.5074C2.07922 24.0348 1.01218 24.3859 0.665386 25.3447C-1.56208 32.353 3.01291 42.3322 12.523 47.8011C14.4037 48.8679 16.391 49.7051 18.1517 50.2993C27.5417 53.1485 37.5186 48.3953 41.3867 39.726L52.2972 15.244C53.7111 12.0302 53.8178 8.23565 52.2972 5.26487C48.5359 -1.74349 39.0392 0.160517 33.864 1.57839C32.5702 1.92948 31.2764 2.41561 29.9959 3.1178Z"
        fill="#FFC700"
      />
    </svg>
  );
}
